export enum PageViewType {
  BOARD = "board",
  // LIST = "list",
  TABLE = "table",
}

export const pageViewTypes: PageViewType[] = [
  PageViewType.BOARD,
  // PageViewType.LIST,
  PageViewType.TABLE,
];

export const pageViewTypeLabels = {
  board: "Board",
  list: "List",
  table: "Table",
};

export interface PageView {
  "view-id"?: string;
  name: string;
  "view-type": PageViewType;
  type: "omega/query-omega/page/view/PageView";
  "app-id": string;
  "page-id": string;
  rank?: string;
}

export interface PageViewsMap {
  [viewId: string]: PageView;
}

export interface PageToPageViewsMap {
  [pageId: string]: PageView[];
}

export interface BoardPageView extends PageView {
  "view-type": PageViewType.BOARD;
  "group-by"?: string;
}

export const getViewPropId = (config: { pageId: string; propId: string }) => {
  const { pageId, propId } = config;
  return `PROPERTY_VALUE_${propId}_${pageId}`;
};
